import Hero from "./Hero";
import Footer from "./Footer";
import Panel from "./Panel";
import FeatureList from "./FeatureList";
import Subscriptions from "./Subscriptions";
import Header from "./Header";
import Testimonials from "./Testimonials";

function Main() {
  return (
    <div className="Main" style={{ maxWidth: "100vw", overflowX: "hidden" }}>
      <Header />
      <br />
      <br />
      <br />
      <Hero />
      {/* <ThreeColumns /> */}
      <Panel />
      <FeatureList />
      <Testimonials />
      <hr style={{ border: "0.5px solid #161C2A" }} />
      <Subscriptions />
      <hr style={{ border: "0.5px solid #161C2A" }} />
      <Footer />
    </div>
  );
}

export default Main;
